import { Skeleton } from "@vega-core/components/shadcn/skeleton";

export const RolesTabSkeleton = () => (
  <div className="flex flex-col gap-4">
    <div className="py-4">
      <Skeleton className="w-full h-4 p rounded" />
    </div>
    <div className="py-4">
      <Skeleton className="w-full h-4 p rounded" />
    </div>
    <div className="py-4">
      <Skeleton className="w-full h-4 p rounded" />
    </div>
  </div>
);
